module.exports = __webpack_public_path__ + "static/img/logo-sp-white.be4c0ef3.png";